import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { AxiosPromise } from 'axios';
import type {
    FranchiseHubClientInterface,
    FranchiseHubDashboardResponse,
    FranchiseHubLayoutDocument,
    FranchiseHubLayoutResponse,
} from './franchiseHubClient.types';

export default class CorporateFranchiseHubClient extends BaseClient implements FranchiseHubClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getDashboard(extraConfig?: ExtendedAxiosRequestConfig): AxiosPromise<FranchiseHubDashboardResponse> {
        const url = `/api/v3/teams/${this.teamId}/franchise-hub/dashboard`;
        return this.makeCoreApiRequest(url, 'get', null, null, extraConfig);
    }

    updateLayout(layout: FranchiseHubLayoutDocument): AxiosPromise<FranchiseHubLayoutResponse> {
        const url = `/api/v3/teams/${this.teamId}/franchise-hub/layout`;
        return this.makeCoreApiRequest(url, 'put', layout);
    }

    deleteLayout(): AxiosPromise<void> {
        const url = `/api/v3/teams/${this.teamId}/franchise-hub/layout`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}
